export class Login {

  constructor(
    public schoolPin: string,
    public pupilPin: string,
    public buildVersion: string
  ) {  }
}
